// 降税管理
const map = {
  taxCutGiftsManag: () => import('@/views/taxCutManagement/TaxCutGiftsManag'), // 赠品管理
  taxCutWdtPackagesManag: () => import('@/views/taxCutManagement/TaxCutWdtPackagesManag'), // 旺店通组合装
  taxCutBomManag: () => import('@/views/taxCutManagement/TaxCutBomManag'), // BOM物料清单
  taxCutGoodsStatistics: () => import('@/views/taxCutManagement/TaxCutGoodsStatistics'), // 降税商品
  taxCutOrdersStatistics: () => import('@/views/taxCutManagement/TaxCutOrdersStatistics'), // 降税订单
  taxCutOrdersStatisticsDetail: () => import('@/views/taxCutManagement/TaxCutOrdersStatistics/TaxCutOrdersStatisticsDetail') // 降税订单详情
}

export default map
